<ng-container *transloco="let t">
  @if (product(); as product) {
    <div class="flex w-full items-center justify-between">
      @if (product | asinInelligilibleForInventoryRule) {
        <IIcon name="alertTriangle" class="warning" [iTooltip]="t('inventory-table.pause_threshold_tooltip')" />
      }

      <button
        iButton
        variant="ghost"
        size="sm"
        (click)="setupRuleOnAsin(product); $event.stopPropagation()"
        [disabled]="isReadOnly()"
      >
        <IIcon name="edit" />
        {{ label() }}
      </button>
    </div>
  }
</ng-container>
